import { render } from "./ExportRRIM_Document.vue?vue&type=template&id=649e22f2"
import script from "./ExportRRIM_Document.vue?vue&type=script&lang=js"
export * from "./ExportRRIM_Document.vue?vue&type=script&lang=js"

import "./ExportRRIM_Document.vue?vue&type=style&index=0&id=649e22f2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__